import CircleBadge from "../../common/CircleBadge";
import { ButtonVariants } from "../../common/Button/constants";
import * as styledElements from "./ReleaseCardStyles";
import { datetimeStringToHumanReadableDate } from "../../../utils/valueFormatting";
import { getByLine, PostView } from "../../../utils/posts";

export default function ReleaseCard({ post }: { post: PostView }) {
  return (
    <styledElements.Card>
      <styledElements.CardHeader>
        <div>{datetimeStringToHumanReadableDate(post.date_released)}</div>
        <styledElements.ElementLink href={post.path}>
          <CircleBadge
            iconProps={{
              src: "/icons/expand_right.svg",
              alt: post.title,
              iconDimension: 8,
            }}
            styleProps={{
              width: "32px",
              height: "32px",
            }}
            type={ButtonVariants.PRIMARY}
          />
        </styledElements.ElementLink>
      </styledElements.CardHeader>
      <styledElements.ElementLink href={post.path}>
        <styledElements.Title>{post.title}</styledElements.Title>
        <styledElements.SubTitle>{post.subtitle}</styledElements.SubTitle>
      </styledElements.ElementLink>
      <styledElements.AuthorAndLocation>
        {getByLine(post)}
      </styledElements.AuthorAndLocation>
    </styledElements.Card>
  );
}
